import { ROLE_CONFIG } from '@/constants/user'
import { User } from '@/lib/types/UserT'
import { cn } from '@/lib/utils'
import Avatar from '@/components/livecontact/Avatar'
import Badge from '@/components/livecontact/Badge'
import LcIcon from '@/components/livecontact/icons'
import { OPTION_CLASS } from '@/components/livecontact/fieldStyles'

/** Option row: avatar tile, name + email, role chip, check that pops in when selected. */
const UserDropdownItem = ({
  user,
  isSelected,
  onSelect,
}: {
  user: User
  isSelected: boolean
  onSelect: (user: User) => void
}) => {
  const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.email
  const config = ROLE_CONFIG[user.companyRole as keyof typeof ROLE_CONFIG] || ROLE_CONFIG.default

  return (
    <button
      type="button"
      role="option"
      aria-selected={isSelected}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onSelect(user)}
      className={cn(
        OPTION_CLASS,
        'py-1.5',
        isSelected && 'bg-surface-2 text-ink dark:bg-surface-3'
      )}
    >
      <Avatar name={fullName} size={28} />
      <span className="min-w-0 flex-1">
        <span className="block truncate">{fullName}</span>
        <span className="block truncate text-[12px] font-normal text-ink-4">{user.email}</span>
      </span>
      {config.label && (
        <Badge tone="neutral" size="sm" className="shrink-0">
          {config.label}
        </Badge>
      )}
      <span className="inline-flex w-4 shrink-0 justify-center">
        {isSelected && (
          <LcIcon name="check" strokeWidth={2} className="text-brand animate-lc-pop" />
        )}
      </span>
    </button>
  )
}

export default UserDropdownItem
